module.exports = __webpack_public_path__ + "img/Frame-71.45db7dd1.svg";